export const RateViewerTypes = {
  rateBrowser: 'rateBrowser',
  csw: 'csw',
};
